import Phaser from "phaser";
import { Colors } from "../../consts/Colors";
import { Fonts } from "../../consts/Fonts";

export default class Button extends Phaser.GameObjects.Container {
    constructor(scene, x, y, params) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.isLocked = false


        const img = this.scene.add.sprite(0, 0, "bouton").setOrigin(0, 0.5)
        this.add(img)

        const text = this.scene.add.text(img.height + 10, 0, "Fermer", {
            font: "20px " + Fonts.MasiliaRegular,
            resolution: 2,
            color: Colors.Text.White
        }).setOrigin(0, 0.5)
        this.add(text)

        var W = img.width + 10 + text.width

        img.x -= W /2
        text.x -= W/2
        
        this.setSize(W, img.height);
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })

        this.pointerOut()
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
                this.disableInteractive()
                clickFunction(this);
        });
    }


    pointerOver(){
        // Ajout de l'animation du hover
        this.scene.tweens.add({
            targets: [ this],
            duration: 200,
            alpha: 1
        })
    }

    pointerOut(){
        // Ajout de l'animation du hover   
        this.scene.tweens.add({
            targets: [ this],
            duration: 200,
            alpha: .95
        })     
    }
}